import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      pass: '',
      cpass: '',
      error: ''
    }
  },
  components: {
    HomeHeader
  },
  mounted () {
    // code of segment integration
    window.analytics.identify('CreateNewPassword', {
      path: '/CreateNewPassword'
    })
    // window.analytics.page('CreateNewPassword')
  },
  computed: {},
  methods: {
    async updatePassword () {
      this.error = ''
      if (!this.pass) {
        this.error = 'Please enter password.'
        showErrorToast(this, this.error)
        return
      }
      if (this.pass.length < 8) {
        this.error = 'Please enter password of minimum 8 characters.'
        showErrorToast(this, this.error)
        return
      }
      if (this.cpass !== this.pass) {
        console.log(this.pass, this.cpass)
        this.error = 'Password and Confirm Password does not match.'
        showErrorToast(this, this.error)
        return
      }
      this.loading = true
      const success = await UserService.resetPassword(
        localStorage.getItem('reset-token'),
        this.pass
      )
      this.loading = false
      if (success) {
        localStorage.removeItem('password-token')
        localStorage.removeItem('reset-token')
        showSuccessToast(this, 'Password Updated Successfully')
        // await UserService.refreshUser()
        this.$router.push('/sign_in')
      } else {
        this.error = 'Unable to reset password.'
        showErrorToast(this, this.error)
      }
    }
  }
}
